import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const PhotoGallerySchema = ({
  title = "",
  description = "",
  keywords = "",
  canonical_url = "",
  image = "",
  publishedAt = "",
  modifiedAt = "",
}) => {
  return (
    <Head>
      <script
        id="ImageGallerySchema"
        key="img-gallery-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ImageGallery",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": canonical_url?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${canonical_url}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            },
            headline: title,
            description: description,
            ...(keywords && { keywords: keywords }),
            image: {
              "@type": "ImageObject",
              height: 515,
              width: 850,
              url: image,
            },
            inLanguage: siteInfo.siteLanguage,
            datePublished: publishedAt,
            dateModified: modifiedAt,
            // dateCreated: createdAt,
            // articleBody: articleBody || description,
            // author: {
            //   "@type": "Person",
            //   name: authorName,
            //   url: authorCanonicalUrl?.includes(
            //     process.env.NEXT_PUBLIC_WEBSITE_URL
            //   )
            //     ? `${authorCanonicalUrl}`
            //     : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            // },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              logo: {
                "@type": "ImageObject",
                url: `${siteInfo?.newSiteLogo}`,
                height: 60,
                width: 600,
              },
            },
            copyrightHolder	: {
                "@type": "Thing",
                name: siteInfo?.siteName,
            },
            sourceOrganization: {
                "@type": "Organization",
                name: siteInfo?.siteName,
            },
            provider: {
                "@type": "Thing",
                name: siteInfo?.siteName,
            },

          }),
        }}
      />
    </Head>
  );
};

export default PhotoGallerySchema;
